import { render } from "./DashboardsVES.vue?vue&type=template&id=3e008a46&scoped=true&ts=true"
import script from "./DashboardsVES.vue?vue&type=script&lang=ts"
export * from "./DashboardsVES.vue?vue&type=script&lang=ts"

import "./DashboardsVES.vue?vue&type=style&index=0&id=3e008a46&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e008a46"]])

export default __exports__